module.exports = __webpack_public_path__ + "static/media/ending-animal-lion.c33e779e.png";